// Divination methods a client is open to (birth-chart based). '不限' (any) is
// mutually exclusive with the specific methods. Stored on a request as
// `divination_types` (array); older records may only have singular `divination_type`.
export const DIVINATION_OPTIONS = [
  { value: 'any', label: '不限' },
  { value: 'bazi', label: '八字' },
  { value: 'ziwei', label: '紫微斗數' },
  { value: 'astrology_western', label: '西洋占星' },
  { value: 'astrology_vedic', label: '印度占星' },
];

const LABELS = {
  any: '不限',
  bazi: '八字',
  ziwei: '紫微斗數',
  astrology_western: '西洋占星',
  astrology_vedic: '印度占星',
  astrology: '占星', // legacy value, kept for older records
};

export function divinationLabel(obj) {
  const types = obj && obj.divination_types && obj.divination_types.length
    ? obj.divination_types
    : (obj && obj.divination_type ? [obj.divination_type] : []);
  if (!types.length) return '—';
  if (types.includes('any')) return '不限';
  return types.map((t) => LABELS[t] || t).join('、');
}
